// 匹配测试路由集合
import { loadPageFail } from '../lib/units';

export default [
    {
        name: 'matchingDetail',
        path: '/matching-detail',
        meta: {
            title: '测试匹配详情页'
        },
        component: resolve => require(['../pages/matching/detail'], resolve)
    },
    {
        name: 'matchingRecord',
        path: '/matching-record',
        meta: {
            title: '匹配记录'
        },
        component: resolve => require(['../pages/matching/record'], resolve)
    },
    {
        name: 'matchingExplain',
        path: '/matching-explain',
        meta: {
            title: '玩法说明'
        },
        component: resolve => require(['../pages/matching/explain'], resolve)
    },
    {
        name: 'matchInvitation',
        path: '/match-invitation',
        meta: {
            title: '匹配邀请页'
        },
        component: resolve => require(['../pages/matching/invitation'], resolve, (err) => {
            loadPageFail({
                pagename: '匹配邀请页',
                err
            })
        })
    },
    {
        name: 'matchIndividualReport',
        path: '/match-individualreport',
        meta: {
            title: '个人报告页'
        },
        component: resolve => require(['../pages/matching/individualReport'], resolve, (err) => {
            loadPageFail({
                pagename: '个人报告页',
                err
            })
        })
    },
    {
        name: 'matchReport',
        path: '/match-report',
        meta: {
            title: '匹配报告页'
        },
        component: resolve => require(['../pages/matching/matchReport'], resolve, (err) => {
            loadPageFail({
                pagename: '匹配报告页',
                err
            })
        })
    },
    {
        name: 'matchBeinvited',
        path: '/match-beinvited',
        meta: {
            title: '匹配被邀请页'
        },
        component: resolve => require(['../pages/matching/beInvited'], resolve, (err) => {
            loadPageFail({
                pagename: '匹配被邀请页',
                err
            })
        })
    }
]


// WEBPACK FOOTER //
// ./src/router/matching.js